import { render } from "./YellowCatIcon.svg?vue&type=template&id=34d92042"
const script = {}
script.render = render

export default script